export default {
  lang: {
    reset: 'Сброс',
    search: 'Фильтрация',
    expand: 'Развернуть',
    collapse: 'Убей',
  },
};
